/**
 * EM: Keep estimated shipping + inflated subtotal in sync after cart AJAX updates.
 */
(function () {
  function getConfig(scope) {
    var node = (scope && scope.querySelector('[data-em-cart-shipping-config]'))
      || document.querySelector('[data-em-cart-shipping-config]');
    if (!node) return null;
    try {
      return JSON.parse(node.textContent);
    } catch (e) {
      return null;
    }
  }

  function formatMoney(cents) {
    if (window.theme && theme.Currency && theme.Currency.formatMoney) {
      return theme.Currency.formatMoney(cents, theme.settings.moneyFormat);
    }
    return (cents / 100).toFixed(2);
  }

  function zoneRate(config, weight) {
    var country = config.country;
    var zones = config.zones || [];
    for (var i = 0; i < zones.length; i++) {
      var countries = zones[i].countries || [];
      if (countries.indexOf(country) === -1) continue;
      var rates = zones[i].rates || [];
      var weights = config.weights || [];
      if (weight <= (weights[0] || 1000)) return rates[0] || 0;
      if (weight <= (weights[1] || 3000)) return rates[1] || 0;
      if (weight <= (weights[2] || 5000)) return rates[2] || 0;
      return rates[3] || rates[rates.length - 1] || 0;
    }
    return null;
  }

  function calcShipping(config, subtotal, weight) {
    var country = config.country;
    var shipping = null;

    if (country === 'DE') {
      shipping = subtotal >= (config.de.threshold || 0) ? 0 : (config.de.rate || 0);
    } else if (country === 'AT') {
      shipping = subtotal >= (config.at.threshold || 0) ? 0 : (config.at.rate || 0);
    } else if (country === 'CH') {
      shipping = config.ch.rate || 0;
    } else {
      shipping = zoneRate(config, weight);
    }

    return shipping;
  }

  function apply(subtotal, weight, requiresShipping) {
    document.querySelectorAll('[data-em-shipping-totals]').forEach(function (root) {
      var config = getConfig(root);
      if (!config || !config.enabled) return;

      var shipping = requiresShipping === false ? null : calcShipping(config, subtotal, weight || 0);
      var show = shipping !== null;
      var isFree = show && shipping === 0;
      var estimated = show ? subtotal + shipping : subtotal;

      var row = root.querySelector('.em-cart-totals__shipping');
      var grandRow = root.querySelector('.em-cart-totals__grand');
      var costEl = root.querySelector('[data-em-shipping-cost]');
      var subtotalEl = root.querySelector('[data-subtotal]');
      var grandEl = root.querySelector('[data-em-cart-grandtotal]');

      if (subtotalEl) {
        subtotalEl.innerHTML = formatMoney(subtotal);
      }

      if (show) {
        if (!row) {
          row = document.createElement('div');
          row.className = 'cart__item-sub cart__item-row em-cart-totals__shipping';
          row.innerHTML =
            '<div class="em-cart-totals__plain em-cart-totals__shipping-label"></div>' +
            '<div class="text-right" data-em-shipping-cost></div>';
          root.appendChild(row);
          costEl = row.querySelector('[data-em-shipping-cost]');
        }
        if (!grandRow) {
          grandRow = document.createElement('div');
          grandRow.className = 'cart__item-sub cart__item-row em-cart-totals__grand';
          grandRow.innerHTML =
            '<div class="cart__subtotal"></div>' +
            '<div class="cart__subtotal text-right" data-em-cart-grandtotal></div>';
          root.appendChild(grandRow);
          grandEl = grandRow.querySelector('[data-em-cart-grandtotal]');
        }
        row.style.display = '';
        grandRow.style.display = '';
        var labelEl = row.querySelector('.em-cart-totals__shipping-label');
        if (labelEl) labelEl.textContent = config.shippingLabel;
        var grandLabelEl = grandRow.querySelector('.cart__subtotal');
        if (grandLabelEl) grandLabelEl.textContent = config.grandTotalLabel || 'Gesamtsumme';
        if (costEl) {
          if (isFree) {
            costEl.textContent = String(config.freeLabel || 'KOSTENLOS').toUpperCase();
          } else {
            costEl.innerHTML = formatMoney(shipping);
          }
          costEl.classList.toggle('em-cart-totals__shipping-free', isFree);
        }
        if (grandEl) {
          grandEl.innerHTML = formatMoney(estimated);
        }
      } else {
        if (row) row.style.display = 'none';
        if (grandRow) grandRow.style.display = 'none';
      }

      var noteRoot = root.parentElement || document;
      noteRoot.querySelectorAll('[data-em-shipping-tax-note] small').forEach(function (el) {
        el.textContent = show ? config.taxNote : config.taxNoteFallback;
      });
    });
  }

  function fromCart(cart) {
    if (!cart) return;
    apply(
      parseInt(cart.total_price, 10) || 0,
      parseInt(cart.total_weight, 10) || 0,
      cart.requires_shipping !== false && (cart.item_count || 0) > 0
    );
  }

  function fromMarkup(form) {
    if (!form) return;
    var holder = form.querySelector('[data-cart-subtotal]');
    if (!holder) return;
    var count = parseInt(holder.getAttribute('data-count'), 10) || 0;
    var requiresShipping = holder.getAttribute('data-requires-shipping') !== 'false' && count > 0;
    apply(
      parseInt(holder.getAttribute('data-cart-subtotal'), 10) || 0,
      parseInt(holder.getAttribute('data-cart-weight'), 10) || 0,
      requiresShipping
    );
  }

  function hookCartForm() {
    if (!window.theme || !theme.CartForm || !theme.CartForm.prototype) return false;
    if (theme.CartForm.prototype._emShippingHooked) return true;

    var original = theme.CartForm.prototype.cartMarkup;
    theme.CartForm.prototype.cartMarkup = function (text) {
      original.call(this, text);
      fromMarkup(this.form);
    };
    theme.CartForm.prototype._emShippingHooked = true;
    return true;
  }

  document.addEventListener('cart:updated', function (evt) {
    if (evt && evt.detail && evt.detail.cart) {
      fromCart(evt.detail.cart);
    }
  });

  if (!hookCartForm()) {
    window.addEventListener('load', hookCartForm);
  }
})();
